import { render, staticRenderFns } from "./CurriculumStatistics.vue?vue&type=template&id=4aa23282&scoped=true"
import script from "./CurriculumStatistics.vue?vue&type=script&lang=js"
export * from "./CurriculumStatistics.vue?vue&type=script&lang=js"
import style0 from "./CurriculumStatistics.vue?vue&type=style&index=0&id=4aa23282&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa23282",
  null
  
)

export default component.exports